import { Flex } from '@mantine/core'

import { AdvisorItem } from '@/modules/advisorsPage/components/AdvisorItem/AdvisorItem'
import type { AdvisorsListProps } from '@/modules/advisorsPage/components/AdvisorsList/AdvisorsList.types'

import { Loader } from '@/components/Loader/Loader'
import { ScrollArea } from '@/components/ScrollArea/ScrollArea'
import { Text } from '@/components/Text/Text'

import classes from './AdvisorsList.module.css'

export function AdvisorsList({
  advisors,
  allowedAdvisors,
  isLoading,
  onSelectAdvisor,
  selectedAdvisorId,
}: AdvisorsListProps) {
  advisors.sort((a, b) => {
    const aAllowed = allowedAdvisors.includes(a.id)
    const bAllowed = allowedAdvisors.includes(b.id)

    if (aAllowed && !bAllowed) {
      return -1
    }

    if (!aAllowed && bAllowed) {
      return 1
    }

    return 0
  })

  const otherAdvisors = advisors.filter(
    ({ id }) => !allowedAdvisors.includes(id),
  )

  if (isLoading)
    return (
      <Flex align="center" className={classes.container} justify="center">
        <Loader isMinimized />
      </Flex>
    )

  if (!advisors.length)
    return (
      <Flex align="center" className={classes.container} justify="center">
        <Text variant="body_1_grey">No planners found</Text>
      </Flex>
    )

  return (
    <Flex className={classes.container}>
      <ScrollArea scrollbars="y">
        {allowedAdvisors.map(advisor => (
          <AdvisorItem
            key={advisor}
            advisor={advisors.find(({ id }) => id === advisor)!}
            onSelectAdvisor={onSelectAdvisor}
            selected={selectedAdvisorId === advisor}
          />
        ))}

        {otherAdvisors.length > 0 && allowedAdvisors.length > 0 && (
          <Text
            c="var(--mantine-other-colors-grey)"
            p={16}
            pt={24}
            tt="uppercase"
            variant="body_4_semibold"
          >
            Other planners
          </Text>
        )}

        {otherAdvisors.map(advisor => (
          <AdvisorItem
            key={advisor.id}
            advisor={advisor}
            onSelectAdvisor={onSelectAdvisor}
            selected={selectedAdvisorId === advisor.id}
          />
        ))}
      </ScrollArea>
    </Flex>
  )
}
